<template>
  <PModalBox
    :open-dialog="openDialog"
    size="medium"
    header="Export suppliers"
    content-alignment="center"
    @close-dialog="close"
  >
    <template #content>
      <p class="appkit-subheading mt-4">Choose export format</p>
      <div class="button-container">
        <PIconButton
          appkit-icon="icon-download-cloud-outline"
          href="/api/suppliers/export?exportType=1"
        >
          Excel
        </PIconButton>
        <PIconButton
          appkit-icon="icon-download-cloud-outline"
          href="/api/suppliers/export?exportType=0"
        >
          CSV
        </PIconButton>
      </div>
    </template>
  </PModalBox>
</template>

<script setup lang="ts">
import PIconButton from "@/components/custom/buttons/PIconButton.vue";
import PModalBox from "@/components/custom/PModalBox.vue";

const emit = defineEmits<{
  (e: "close-dialog"): void;
}>();

defineProps<{
  openDialog: boolean;
}>();

const close = () => {
  emit("close-dialog");
};
</script>
